// extracted by mini-css-extract-plugin
module.exports = {"container":"_3IjKr","cover":"_2BCu7","coverImage":"_2tqaD","details":"_9166U","title":"_2S5cX","categoryLink":"_3dOhM","moreButton":"_2C1LW","statistics":"MkVsK"};